import { Text } from '@typedream/ui';
import Button from '@/sharedComponents/v1/Components/Button';
import { styButtonIcon, styContainer, styIconContainer } from './style';
import { InfoCardPropType } from './type';

export function InfoCard({
  icon,
  buttonIcon,
  width = 450,
  height = 300,
  title,
  subtitle,
  buttonText,
  onClick,
  margin,
}: InfoCardPropType) {
  return (
    <div
      css={styContainer}
      style={{
        width,
        minHeight: height,
        margin,
      }}
    >
      <div css={styIconContainer}>{icon}</div>
      <div className="space-y-2">
        <Text as="p" size="xl" variant="main" weight="bold">
          {title}
        </Text>
        <Text as="p" size="md" variant="mute">
          {subtitle}
        </Text>
      </div>
      {onClick && (
        <Button
          onClick={onClick}
          type="primary"
          width="full"
          className="is-flex is-align-items-center"
          prefix={buttonIcon && <span css={styButtonIcon}>{buttonIcon}</span>}
        >
          {buttonText}
        </Button>
      )}
    </div>
  );
}
